import {
  EMemberRole,
  TDocument,
  TDocumentsGroup,
  TNewMessageNotification,
  TReadedCommentNotification,
} from "../types";
import { bimFolderRegex } from "../constants";
import { message } from "antd";

export const isBoolean = (value: unknown): value is boolean =>
  typeof value === "boolean";

export const isMemberRole = (value: any): value is EMemberRole =>
  Object.values(EMemberRole).includes(value);

// Проверка на роль проектного института (является частью проектной команды, но доступы ограничены)
export const isPIRole = (
  role: EMemberRole
): role is
  | EMemberRole.ARCHITECTURAL_SUPERVISION
  | EMemberRole.CHIEF_PROJECT_ENGINEER_PI =>
  [
    EMemberRole.ARCHITECTURAL_SUPERVISION,
    EMemberRole.CHIEF_PROJECT_ENGINEER_PI,
  ].includes(role);

export const isNewMessageNotification = (
  value: any
): value is TNewMessageNotification => !!value.message_id;

export const isReadedCommentNotification = (
  value: any
): value is TReadedCommentNotification =>
  !!value.comment_id && !value.message_id;

export const sendSuccessMessage = (customText = "Данные успешно обновлены") => {
  message.success({
    content: customText,
    key: "success",
  });
};

export const sendErrorMessage = (
  error: any,
  customText = "Ошибка при загрузке данных"
) => {
  message.error({
    content: error.detail ?? customText,
    key: "error",
  });
};

export const findLinkToFolder = (documentation: TDocumentsGroup): string => {
  const bimDocument = documentation.documents.find((doc) =>
    bimFolderRegex.test(doc.fileBimUri ?? "")
  );

  if (bimDocument) {
    return (bimDocument.fileBimUri?.match(bimFolderRegex) ?? [""])[0];
  }

  return "";
};

export const convertBimRequest = (documentation: TDocument) => {
  if (
    documentation.fileUri &&
    documentation.fileBimUri &&
    // url was changed
    documentation.fileBimUri.includes("some_url")
  ) {
    return `${window.location.origin}/${documentation.fileUri}`;
  }

  return documentation.fileBimUri;
};

export const getResponsibleEngineerIconColor = (role: EMemberRole) => {
  switch (role) {
    case EMemberRole.ARCHITECTURAL_SUPERVISION:
      return "#722ed1";
    case EMemberRole.CHIEF_PROJECT_ENGINEER:
      return "#13c2c2";
    case EMemberRole.CHIEF_PROJECT_ENGINEER_PI:
      return "#2f54eb";
    case EMemberRole.PROJECT_MANAGER:
      return "#52c41a";

    default:
      return "#13c2c2";
  }
};
